import { render, staticRenderFns } from "./OrderPreviewParty.vue?vue&type=template&id=85a6e8ba&scoped=true"
import script from "./OrderPreviewParty.vue?vue&type=script&lang=ts"
export * from "./OrderPreviewParty.vue?vue&type=script&lang=ts"
import style0 from "./OrderPreviewParty.vue?vue&type=style&index=0&id=85a6e8ba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a6e8ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85a6e8ba')) {
      api.createRecord('85a6e8ba', component.options)
    } else {
      api.reload('85a6e8ba', component.options)
    }
    module.hot.accept("./OrderPreviewParty.vue?vue&type=template&id=85a6e8ba&scoped=true", function () {
      api.rerender('85a6e8ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/OrderPreviewParty.vue"
export default component.exports